import { Sentry } from './sentry';

type BetaSeverity = 'info' | 'warning' | 'error';

type BetaEventData = Record<string, string | number | boolean | null | undefined>;

function sanitize(data: BetaEventData = {}): BetaEventData {
  const cleaned: BetaEventData = {};
  for (const [key, value] of Object.entries(data)) {
    if (/name|email|photo|caption|journal|birth/i.test(key)) continue;
    cleaned[key] = value;
  }
  return cleaned;
}

export function logBetaEvent(
  event: string,
  data: BetaEventData = {},
  severity: BetaSeverity = 'info',
): void {
  try {
    const extra = sanitize(data);
    Sentry.addBreadcrumb({
      category: 'beta',
      message: event,
      level: severity,
      data: extra,
    });
    if (severity !== 'info') {
      Sentry.captureMessage(`[beta] ${event}`, severity === 'warning' ? 'warning' : 'error');
    }
  } catch {
    // Never break user flows for observability.
  }
}

export function logBetaIssue(
  event: string,
  error: unknown,
  data: BetaEventData = {},
): void {
  try {
    Sentry.captureException(error, {
      tags: { area: 'beta' },
      extra: sanitize(data),
    });
    Sentry.addBreadcrumb({
      category: 'beta',
      message: `${event}: failure`,
      level: 'error',
      data: sanitize(data),
    });
  } catch {
    // No-op
  }
}
